export default __webpack_public_path__ + "static/media/gallery_08.198496e0.jpg";